var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8972 17.1826L53.8858 9.64609L39.1612 0.555603V6.36947L48.8736 12.4095L48.8811 17.0391L44.3692 19.9245L41.2912 17.8034V14.2111L36.2752 10.9703V17.5092L28.3239 22.1173L28.3089 34.2905L22.687 37.28L19.8008 35.1446V31.6203L23.2175 29.4096V29.381V23.9259L17.0688 27.8126L12.3689 24.9237L8.07535 27.5794L14.7847 31.9183V34.5812L9.9493 37.6712L5.01604 34.5166V24.0193L12.3389 19.3358L12.3464 14.832L21.7387 20.5452L29.6335 15.582L24.8205 12.9298L21.671 14.9359L14.8111 10.651L22.5477 6.39101L29.2496 10.1019V4.5679L22.5553 0.860638L7.33781 9.24058L7.32651 16.7806L0 21.4676V37.0682L7.32651 41.7552L7.33781 49.2953L22.0624 58.3822V52.5719L12.35 46.5319L12.3425 41.9023L16.8544 39.0169L19.9324 41.1379V44.7303L24.9485 47.9711V41.4322L33.0126 36.8242L33.1029 24.6509L38.5366 21.6614L41.4228 23.7968V27.3209L38.0061 29.5316V29.5604V35.0153L44.1548 31.1287L48.8548 34.0177L53.1482 31.362L46.4389 27.0195V24.3602L51.2743 21.2702L56.2076 24.4248V34.9221L48.8848 39.6055L48.8773 44.1094L39.485 38.3926L31.5902 43.3236L36.4031 45.972L39.5526 44.0053L46.4126 48.2904L38.6759 52.5504L31.974 48.8395V54.3699L38.6684 58.0772L53.8858 49.7008L53.8972 42.1607L61.2236 37.4737V21.8696L53.8972 17.1826Z",
    fill: "#1A1915"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogo);
export default __webpack_public_path__ + "static/media/black-logo.f721e34e6962de9f101921144727a542.svg";
export { ForwardRef as ReactComponent };